import * as React from 'react';

/**
 * Minimum time to wait before considering the browser idle.
 * 2000ms avoid slowing down the initial render.
 */
const MIN_WAIT_TIME = 2000;

/**
 * Hook returning whether the browser is idle after waiting long enough to avoid slowing down the initial render.
 * @param minWaitTime Minimum time to wait before considering the browser idle.
 */
export function useIsBrowserIdle(): boolean {
    const [isIdle, setIdle] = React.useState(false);

    React.useEffect(() => {
        let idleCallback: number | undefined;
        const timeout = window.setTimeout(() => {
            if (typeof requestIdleCallback === 'function') {
                idleCallback = requestIdleCallback(() => setIdle(true), {
                    timeout: MIN_WAIT_TIME,
                });
            } else {
                setIdle(true);
            }
        }, MIN_WAIT_TIME);

        return () => {
            window.clearTimeout(timeout);
            if (idleCallback !== undefined && typeof cancelIdleCallback === 'function') {
                cancelIdleCallback(idleCallback);
            }
        };
    }, []);

    return isIdle;
}
